const {CSRF_TOKEN} = require('./csrf');

window.axios = require('axios').default;

window.axios.defaults.headers.common['X-CSRF-TOKEN'] = CSRF_TOKEN;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
